import { isUnsafeKey } from '../safeFunctions/schema.js';
function invalidEntry(id, message) {
    throw new Error(`Invalid split rule set entry "${id}": ${message}`);
}
export function validateSplitRuleSetEntry(id, entry) {
    if (isUnsafeKey(id)) {
        invalidEntry(id, 'the id is not allowed; give the rule another id');
    }
    if (!entry || typeof entry !== 'object') {
        invalidEntry(id, 'the entry must be an object');
    }
    if (entry.id !== undefined && entry.id !== id) {
        invalidEntry(id, `the entry states id "${entry.id}", but its key is the id. Remove the id, or make it equal to the key.`);
    }
    const { priority } = entry;
    if (priority === null) {
        return false;
    }
    if (typeof priority !== 'number' || !Number.isFinite(priority)) {
        invalidEntry(id, `priority must be a finite number, or null to exclude the rule; got ${JSON.stringify(priority)}`);
    }
    return true;
}
export function orderSplitRuleSetEntries(ruleSet) {
    if (!ruleSet || typeof ruleSet !== 'object' || Array.isArray(ruleSet)) {
        throw new Error(`A split rule set must be an object keyed by rule id: ${JSON.stringify(ruleSet)}`);
    }
    const included = [];
    for (const [id, entry] of Object.entries(ruleSet)) {
        if (validateSplitRuleSetEntry(id, entry)) {
            included.push({ id, priority: entry.priority, entry });
        }
    }
    included.sort((a, b) => {
        if (a.priority !== b.priority) {
            return a.priority - b.priority;
        }
        return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
    });
    return included.map(({ id, entry }) => {
        const { priority, ...rule } = entry;
        return { ...rule, id };
    });
}
export function resolveSplitRuleSet(ruleSet) {
    return orderSplitRuleSetEntries(ruleSet);
}
